import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


export default function FormDialog(props) {
  const {children, open, setOpen, fullScreen} = props
  const icon_style = {
    width: '100%',
    display: 'flex',
    justifyContent: 'end'
  }
  return (
      <Dialog open={open} scroll={'body'} fullScreen={fullScreen} fullWidth={true} onClose={() => setOpen(false)}>
        
        <DialogTitle>
          <div style={icon_style}>
          <IconButton sx={{m: 1}} size='small' onClick={() => setOpen(false)}>
           <CloseIcon /> 
          </IconButton>
        </div>
        </DialogTitle>
        <DialogContent >
          {children}
        </DialogContent>
      </Dialog>
  )
}

